module.exports = __webpack_public_path__ + "static/media/network.53f52a4d.svg";